<template>
  <div>
    <Loading v-if="initialLoad"></Loading>
    <Layout v-else>
      <div class="pt-4">
        <h3 style="font-weight: bold">Bank Transfer Transactions</h3>
      </div>
      <section class="pt-5">
        <Overview class="overview">
          <p slot="card-1-title">Total Transfer Transaction Value</p>
          <h3 slot="card-1-val">
            ₦<ICountUp
              :delay="delay"
              :endVal="totalBankTransferSumValue"
              :options="options"
              @ready="getTotalBankTransferSumValue"
            />
          </h3>

          <p slot="card-2-title">Total Transfer Transaction Volume</p>
          <h3 slot="card-2-val">
            <ICountUp
              :delay="delay"
              :endVal="totalBankTransferVolume"
              :options="options"
              @ready="getTotalBankTransferVolume"
            />
          </h3>
        </Overview>
      </section>
      <section class="pt-5">
        <TransactionsList>
          <b-form-input
            slot="search-bar"
            type="search"
            placeholder="Search shown entries"
            v-model="filter"
            trim
          />
          <b-form-select
            class="show-select"
            slot="select-entry"
            value="1"
            :options="bankTransferEntries"
          ></b-form-select>
          <span slot="entries-no"
            >of {{ bankTransferEntries.length }} entries</span
          >
          <b-form-datepicker
            slot="start-date"
            id="al-start-date"
            placeholder="Start date"
            locale="en"
            class="filter-date"
            :max="today"
            @input="enableEndDate"
            v-model="startDate"
          ></b-form-datepicker>
          <b-form-datepicker
            slot="end-date"
            id="al-end-date"
            placeholder="End date"
            locale="en"
            class="filter-date"
            :disabled="disabled"
            :min="startDate"
            :max="today"
            @input="enableApply"
            v-model="endDate"
          ></b-form-datepicker>
          <b-form-input
            slot="start-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="end-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="status-input"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-checkbox
            slot="save-default"
            class="save-filter"
            id="save-filter"
          >
            Save as default filter
          </b-form-checkbox>
          <b-button
            slot="clear-btn"
            class="btn-alt filter-btn"
            block
            variant="primary"
            @click="clearFilter"
          >
            Clear
          </b-button>
          <b-button
            slot="apply-btn"
            slot-scope="{ closeModal }"
            class="filter-btn"
            block
            variant="primary"
            @click="
              closeModal();
              applyFilter();
            "
          >
            Apply
          </b-button>
          <b-table
            slot="table"
            hover
            responsive
            :items="bankTransferTable"
            :filter="filter"
            :busy="isBusy"
            :empty-filtered-html="emptyImg"
            show-empty
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle mr-1"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
        </TransactionsList>
      </section>
    </Layout>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "@/components/Loading.vue";
import Layout from "@/components/Layout.vue";
import TransactionsList from "@/components/TransactionsList.vue";
import Overview from "@/components/Overview.vue";
import ICountUp from "vue-countup-v2";
import { mapState, mapActions } from "vuex";

export default {
  name: "BankTransfer",
  components: {
    Loading,
    Layout,
    Overview,
    ICountUp,
    TransactionsList,
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      filter: "",
      disabled: true,
      disabledApply: true,
      size: 100,
      today: moment(Date.now()).format("YYYY-MM-DD"),
      pinpadChart: [{ value: 0, color: "#34B53A" }],
      posChart: [{ value: 0, color: "#F5A623" }],
      accountsChart: [{ value: 0, color: "#F21919" }],
    };
  },
  computed: {
    ...mapState({
      initialLoad: (state) => state.bankTransfer.initialLoad,
      refresh: (state) => state.bankTransfer.refresh,
      isBusy: (state) => state.bankTransfer.loading,
      delay: (state) => state.user.delay,
      options: (state) => state.user.options,
      emptyImg: (state) => state.user.empty,

      totalBankTransferSumValue: (state) =>
        state.bankTransfer.bankTransferOverview.totalSumValue,
      totalBankTransferVolume: (state) =>
        state.bankTransfer.bankTransferOverview.totalCount,

      bankTransferTable: (state) => {
        if (state.bankTransfer.bankTransferTransactions.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.bankTransfer.bankTransferTransactions.data;
        }
      },
      bankTransferEntries: (state) => [
        state.bankTransfer.bankTransferTransactions.meta.total,
      ],
    }),
  },
  methods: {
    ...mapActions({
      getBankTransferTransactions: "bankTransfer/getBankTransferTransactions",
      getBankTransferOverview: "bankTransfer/getBankTransferOverview",
    }),
    getTotalBankTransferSumValue(instance) {
      const that = this;
      instance.update(that.totalBankTransferSumValue);
    },
    getTotalBankTransferVolume(instance) {
      const that = this;
      instance.update(that.totalBankTransferVolume);
    },
    getTodayData() {
      this.getBankTransferTransactions({
        startDate: this.today,
        endDate: this.today,
      });
      this.getBankTransferOverview({
        startDate: this.today,
        endDate: this.today,
      });
    },
    refreshData() {
      if (this.startDate.length < 1 && this.endDate.length < 1) {
        this.getTodayData();
      }
      if (this.startDate.length > 1 && this.endDate.length > 1) {
        this.applyFilter();
      }
    },
    applyFilter() {
      this.getBankTransferTransactions({
        startDate: this.startDate,
        endDate: this.endDate,
      });
      this.getBankTransferOverview({
        startDate: this.startDate,
        endDate: this.endDate,
      });
    },
    clearFilter() {
      (this.startDate = ""), (this.endDate = "");
    },
    enableEndDate() {
      this.disabled = false;
    },
    enableApply() {
      this.disabledApply = false;
    },
  },
  watch: {
    refresh() {
      if (this.refresh === true) {
        console.log("Refresh Bank Transfer");
        this.refreshData();
      }
    },
  },
  created() {
    document.title = "Bank Transfer | ReadyCash Aggregator Portal";
    this.getTodayData();
  },
};
</script>

<style lang="scss" scoped>
.agents-trans-select {
  width: 10vw;
  margin-right: 1rem;
}
.search-form input {
  border-radius: 5px;
}
</style>
